import { __read, __spreadArray, __values } from "tslib";
import { useActionControls, useHubActionsConfig, } from '@office-start/actions-service';
import { useShellShim } from '@office-start/shell-shim-service';
import { useCallback } from 'react';
import { getBuiltInActions, getMosAppActions, } from '../MosAppContentActionService';
export var useRegisterMosAppActions = function () {
    var _a;
    var actionControls = useActionControls();
    var shellShim = useShellShim();
    var _b = __read(useHubActionsConfig(), 4), documentActionsMenuResources = _b[0], documentActionsToastResources = _b[1], actionsInContextDialogResources = _b[2], hubActionsConfig = _b[3];
    var callback = useCallback(function (appDefinitions) {
        var e_1, _a;
        var _b, _c;
        if (!(actionControls === null || actionControls === void 0 ? void 0 : actionControls.actionManager) ||
            !documentActionsMenuResources ||
            !documentActionsToastResources ||
            !actionsInContextDialogResources ||
            !hubActionsConfig ||
            !appDefinitions) {
            return;
        }
        var allActions = (_b = getBuiltInActions(appDefinitions, {
            actionsInContextDialogResources: actionsInContextDialogResources,
            documentActionsMenuResources: documentActionsMenuResources,
            documentActionsToastResources: documentActionsToastResources,
        }, hubActionsConfig)) !== null && _b !== void 0 ? _b : [];
        var mosAppData = [];
        try {
            for (var appDefinitions_1 = __values(appDefinitions), appDefinitions_1_1 = appDefinitions_1.next(); !appDefinitions_1_1.done; appDefinitions_1_1 = appDefinitions_1.next()) {
                var app = appDefinitions_1_1.value;
                if (app.actions) {
                    var actionsOfApp = getMosAppActions(app, hubActionsConfig);
                    actionsOfApp && allActions.push.apply(allActions, __spreadArray([], __read(actionsOfApp), false));
                }
                if (app.id &&
                    app.name &&
                    app.smallImageUrl &&
                    app.largeImageUrl) {
                    mosAppData.push({
                        id: app.id,
                        name: app.name,
                        smallImageUrl: app.smallImageUrl,
                        largeImageUrl: app.largeImageUrl,
                    });
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (appDefinitions_1_1 && !appDefinitions_1_1.done && (_a = appDefinitions_1.return)) _a.call(appDefinitions_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (mosAppData && mosAppData.length > 0) {
            (_c = shellShim === null || shellShim === void 0 ? void 0 : shellShim.shellShim) === null || _c === void 0 ? void 0 : _c.Search.SetMosAppsData(mosAppData);
        }
        allActions.length > 0 &&
            (actionControls === null || actionControls === void 0 ? void 0 : actionControls.actionManager.registerResolvedActions(allActions));
    }, [
        actionControls === null || actionControls === void 0 ? void 0 : actionControls.actionManager,
        actionsInContextDialogResources,
        documentActionsMenuResources,
        documentActionsToastResources,
        hubActionsConfig,
        (_a = shellShim === null || shellShim === void 0 ? void 0 : shellShim.shellShim) === null || _a === void 0 ? void 0 : _a.Search,
    ]);
    return callback;
};
//# sourceMappingURL=useRegisterMosAppActions.js.map